import type { MouseEvent } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { ButtonBase, Typography, useTheme } from "@mui/material";
import { Column } from "../../misc/Column";
import { formatMoney } from "../../misc/Money";
import { Row } from "../../misc/Row";
import type { SubscriptionPackage } from "../../providers/subscriptionPackagesProvider";

export function SubscriptionPackageMobileListItem(props: {
  subscriptionPackage: SubscriptionPackage;
  onClick: (event: MouseEvent<HTMLDivElement>) => void;
}) {
  const { subscriptionPackage, onClick } = props;
  const theme = useTheme();

  return (
    <ButtonBase
      component="div"
      data-testid="SubscriptionPackageMobileListItem"
      onClick={onClick}
      sx={{
        alignItems: "stretch",
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxSizing: "border-box",
        display: "block",
        px: 0,
        py: 1,
        textAlign: "left",
        width: "100%",
      }}
    >
      <Column sx={{ gap: 0.5, minWidth: 0 }}>
        <Row sx={{ alignItems: "center", justifyContent: "space-between", gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, overflowWrap: "anywhere" }}>
            {subscriptionPackage.name}
          </Typography>
          <Typography variant="body2" sx={{ flexShrink: 0, fontWeight: 600 }}>
            {formatMoney(subscriptionPackage.price)}
          </Typography>
        </Row>
        {subscriptionPackage.recommended && (
          <Row sx={{ alignItems: "center", color: "text.secondary", gap: 0.5 }}>
            <CheckCircleOutlineIcon sx={{ fontSize: 16 }} />
            <Typography variant="caption">Empfohlen</Typography>
          </Row>
        )}
        {subscriptionPackage.features.length > 0 && (
          <Column component="ul" sx={{ gap: 0.25, m: 0, pl: 2.5 }}>
            {subscriptionPackage.features.map((feature, index) => (
              <Typography
                component="li"
                key={`${index}-${feature}`}
                variant="caption"
                color="text.secondary"
                sx={{ overflowWrap: "anywhere" }}
              >
                {feature}
              </Typography>
            ))}
          </Column>
        )}
      </Column>
    </ButtonBase>
  );
}
